// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"594":"about","597":"projects"}[chunkId] + "." + {"594":"ac370b7f","597":"9163d851"}[chunkId] + ".js";
};